module.exports = __webpack_public_path__ + "static/1578573386319-ba8dcf6529624f6bd2781646d69246f4.jpg";